<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader @func="getMsgFormSon"></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <Accountset></Accountset>
        <div class="ttshop_accountright">
          <div class="ttshop_siterun">
            <div class="add-address" @click="addAddress()">新增收货地址</div>
            <ul>
              <template v-if="address_list && address_list.length">
                <li v-for="(item, index) in address_list" :key="index">
                  <h5>{{ item.name }} <span v-show="item.is_default == 1">默认地址</span></h5>
                  <p class="clearfloat"><strong>所在地区：</strong><span>{{ item.province }}{{ item.city }}{{ item.district }}</span>
                  </p>
                  <p class="clearfloat"><strong>地址：</strong><span>{{ item.detail }}</span></p>
                  <p class="clearfloat"><strong>手机：</strong><span>{{ item.mobile }}</span></p>
                  <div class="ttshop_siterunliast clearfloat">
                    <strong @click="addressDefault(item.id)">设为默认</strong>
                    <strong @click="changeAddress(index)">编辑</strong>
                    <strong @click="addressDelete(item.id)">删除</strong>
                  </div>
                </li>
              </template>
              <template v-else>
                <div v-if="data_type">您还没有收货地址</div>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址弹窗 -->
    <div class="address-mask">
      <el-dialog :title="addressType == 1 ? '新增收货地址' : '修改收货地址'" :visible.sync="addressVisible">
        <div class="address-mask-box d-flex justify-content-center">
          <div class="address-mask-l d-flex flex-direction-column align-items-end">
            <div class="item-title">收货人：</div>
            <div class="item-title">手机：</div>
            <div class="item-title">所在地区：</div>
            <div class="item-title">详细地址：</div>
          </div>
          <div class="address-mask-r d-flex flex-direction-column">
            <el-input class="item-input" v-model="address_name" placeholder="姓名，如张航"></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_name_type">
                <div class="hint-img">
                  <img class="img-default" src="../../assets/images/hint_icon.png" alt />
                </div>收货人名称最少2位
              </template>
            </div>
            <el-input v-model="address_mobile" placeholder="请填写正确的11位手机号码" maxlength="11"></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_mobile_type">
                <div class="hint-img">
                  <img class="img-default" src="../../assets/images/hint_icon.png" alt />
                </div>请填写正确的手机号
              </template>
            </div>
            <el-cascader
              v-if="addressVisible"
              :options="district_list"
              :props="{ value: 'id', label: 'name', children: 'list' }"
              v-model="address_province"
              @change="provinceChange"
            ></el-cascader>
            
            <div class="hint d-flex align-items-center">
              <template v-if="address_province_type">
                <div class="hint-img">
                  <img class="img-default" src="../../assets/images/hint_icon.png" alt />
                </div>请选择地区
              </template>
            </div>
            <el-input v-model="address_detail" placeholder="街道、小区、楼牌号等"></el-input>
            <div class="hint d-flex align-items-center">
              <template v-if="address_detail_type">
                <div class="hint-img">
                  <img class="img-default" src="../../assets/images/hint_icon.png" alt />
                </div>请填写详细地址
              </template>
            </div>
            <div class="default d-flex align-items-center" @click="change_default">
              <div class="default-img">
                <img class="img-default" src="../../assets/images/select_checked.png" alt v-if="address_is_default" />
                <img class="img-default" src="../../assets/images/select_unchecked.png" alt v-else />
              </div>设为默认收货地址
            </div>
            <div class="address-btn d-flex align-items-center justify-content-center" @click="preserveAddress()">保存</div>
          </div>
        </div>
      </el-dialog>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Accountset from "./components/accountset";
import "./user.css";
export default {
  components: {
    Header,
    Userheader,
    Accountset,
    Foot,
  },
  data () {
    return {
      addressVisible: false,
      address_id: "", // 选中地址id
      address_list: [], // 地址列表
      address_name: "", // 地址-用户名
      address_name_type: false,
      address_mobile: "", // 地址-手机号
      address_mobile_type: false,
      address_province: [], // 地址-省市区
      address_province_type: false,
      address_detail: "", // 地址-详细地址
      address_detail_type: false,
      address_is_default: 0, // 地址-是否设为默认地址
      district_list: [], // 地址省市区列表
      need_save_address_id: "", // 需要修改的地址id
      data_type: false,
      addressType: 1
    };
  },
  mounted () {
    this.addressList();
    this.district();
  },
  methods: {
    getMsgFormSon (data) {
      // console.log(data);
    },
    addressList () {
      this.data_type = false;
      this.$api.addressList().then((res) => {
        this.address_list = res.data.list;
        this.data_type = true;
      }).catch((err) => {
        console.log(err);
      });
    },
    // 删除
    addressDelete (id) {
      let params = {
        address_id: id,
      }
      this.$confirm("确认删除当前地址吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.addressDelete(params).then((res) => {
          this.addressList();
          this.$message({
            type: "success",
            message: "删除成功!",
            showClose: true,
            offset: 200,
            duration: 1000,
          });
        }).catch((err) => {
          console.log(err);
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });
    },
    // 地址列表
    district () {
      this.$api.district().then((res) => {
        this.district_list = res.data;
      }).catch((err) => {
        console.log(err);
      });
    },
    // 选择省市区
    provinceChange (value) {
      // console.log(value);
    },
    // 新增收货地址
    addAddress () {
      this.addressVisible = true;
      this.address_name = "";
      this.address_mobile = "";
      this.address_province = [];
      this.address_detail = "";
      this.address_is_default = 0;
      this.addressType = 1
    },
    //设为默认
    addressDefault (id) {
      let params = {
        address_id: id
      }
      this.$api.addressDefault(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "设置成功!",
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          this.addressList();
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 保存地址
    preserveAddress () {
      let that = this;
      let address_name = this.address_name.trim();
      let address_mobile = this.address_mobile.trim();
      let address_province = this.address_province;
      let address_detail = this.address_detail.trim();
      this.address_name_type = false;
      this.address_mobile_type = false;
      this.address_province_type = false;
      this.address_detail_type = false;
      if (address_name.length < 2) {
        this.address_name_type = true;
        return false;
      } else if (!/^1[3456789]\d{9}$/.test(address_mobile)) {
        this.address_mobile_type = true;
        return false;
      } else if (!address_province.length) {
        this.address_province_type = true;
        return false;
      } else if (!address_detail) {
        this.address_detail_type = true;
        return false;
      }
      let params = {
        name: address_name,
        mobile: address_mobile,
        detail: address_detail,
        lng: "0",
        lat: "0",
        province_id: address_province[0],
        city_id: address_province[1],
        district_id: address_province[2],
        is_default: this.address_is_default,
      };
      if (this.need_save_address_id) {
        params.address_id = this.need_save_address_id;
      }
      this.$api.addressSave(params).then((res) => {
        if (res.code == 0) {
          if (that.need_save_address_id) {
            that.need_save_address_id = "";
            that.$message({
              message: "修改成功",
              showClose: true,
              type: "success",
              offset: 200,
              duration: 1000,
            });
          } else {
            that.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
              offset: 200,
              duration: 1000,
            });
          }
          that.addressList();
          that.addressVisible = false;
          that.address_name = "";
          that.address_mobile = "";
          that.address_province = [];
          that.address_detail = "";
          that.address_is_default = 0;
        }
      })
        .catch((err) => {
          console.log(err);
        });
    },
    // 修改地址
    changeAddress (index) {
      let that = this;
      let address = this.address_list[index];
      this.addressType = 2
      this.address_name = address.name;
      this.address_mobile = address.mobile;
      this.address_province = [
        (address.province_id),
        (address.city_id),
        (address.district_id),
      ];
      this.address_detail = address.detail;
      this.address_is_default = Number(address.is_default);
      this.need_save_address_id = address.id;
      this.addressVisible = true;
    },
    change_default () {
      this.address_is_default = this.address_is_default == 0 ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
//添加地址弹窗
.address-mask {
  .address-mask-l {
    width: 60px;
    margin-right: 16px;

    .item-title {
      height: 28px;
      line-height: 28px;
      margin-bottom: 20px;
    }
  }

  .address-mask-r {
    .hint {
      height: 20px;
      color: #ff8500;

      .hint-img {
        height: 12px;
        width: 12px;
        margin-right: 8px;
      }
    }

    .default {
      .default-img {
        height: 12px;
        width: 12px;
        margin-right: 4px;
      }
    }

    .address-btn {
      cursor: pointer;
      width: 108px;
      height: 32px;
      background: #ff0e25;
      border-radius: 2px;
      color: #fff;
      margin-top: 38px;
    }
  }
}

.ttshop_accountright {
  float: right;
  width: 990px;
  min-height: 537px;
  background: #fff;

  .ttshop_siterun {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .add-address {
      cursor: pointer;
      width: 114px;
      height: 30px;
      background: #FF0E25;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 30px;
    }

    ul {
      margin-top: 18px;

      >div {
        font-size: 14px;
        color: #999;
        text-align: center;
        padding: 30px 0;
      }

      li {
        width: 100%;
        border: 1px solid #ebebeb;
        padding: 16px 16px 16px 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
        position: relative;

        h5 {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          line-height: 14px;
          margin-bottom: 18px;

          span {
            margin-left: 16px;
            font-size: 12px;
            color: #fff;
            border-radius: 2px;
            background: #ff0e25;
            padding: 4px 8px;
            box-sizing: border-box;
          }
        }

        p {
          margin-top: 16px;

          strong {
            float: left;
            width: 60px;
            text-align: right;
            font-size: 12px;
            color: #666;
            margin-right: 12px;
            font-weight: 400;
            line-height: 12px;
          }

          span {
            float: left;
            width: 50%;
            font-size: 12px;
            color: #666;
            margin-right: 12px;
            font-weight: 400;
            line-height: 12px;
          }
        }

        .ttshop_siterunliast {
          position: absolute;
          right: 16px;
          bottom: 16px;

          strong {
            float: left;
            margin-right: 30px;
            font-weight: 400;
            font-size: 12px;
            color: #0e9cff;
            font-weight: 400;
            line-height: 12px;
            cursor: pointer;
            transition: 0.5s;
            -moz-transition: 0.5s;
            -webkit-transition: 0.5s;
            -o-transition: 0.5s;
            opacity: 0.7;

            &:last-child {
              margin-right: 0;
            }

            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
</style>
